module.exports = __webpack_public_path__ + "img/61-white.cfb3aba7.svg";